import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import useRect from '../../../../hooks/useRect.js';

function useSliderScaleFactor(_ref) {
  var max = _ref.max,
    min = _ref.min;
  var _useRect = useRect(undefined, [max, min]),
    _useRect2 = _slicedToArray(_useRect, 2),
    ref = _useRect2[0],
    width = _useRect2[1].width;
  var scaleFactor = width / (max - min) || 1;
  return [ref, scaleFactor];
}

export { useSliderScaleFactor as default };
//# sourceMappingURL=useSliderScaleFactor.js.map
